import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getFuelStationEvents: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENTS,
  },
  getFuelStationEvent: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT,
  },
  getFuelStationEventPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_PREVIEW,
  },
  getFuelStationEventPopup: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_POPUP,
  },
  patchFuelStationEvent: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].PATCH_FUEL_STATION_EVENT,
  },
}